import { Card, CardContent } from "src/components/ui/Card";
import { Avatar, AvatarFallback, AvatarImage } from "src/components/ui/Avatar";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "src/components/ui/Carousel";

const testimonials = [
  {
    content:
      "They broke down each part and helped me understand each step to solve the problem, and then allowed me to show that I understood the process. Extremely helpful with how I learn.",
    author: {
      name: "Aiden",
      subject: "Calculus",
      image: "",
    },
  },
  {
    content:
      "My tutor was very helpful and explained the math problem to me step by step. I felt more confident in solving more problems like these after our session.",
    author: {
      name: "Melissa",
      subject: "Pre-Calculus",
      image: "",
    },
  },
  {
    content:
      "The person I had helping me helped out so much they were able to bring back how to do inverse functions and now I think i will be fine on my exam!",
    author: {
      name: "Andrea",
      subject: "Pre-Calculus",
      image: "",
    },
  },
  {
    content:
      "I like how descriptive he was and really helped out with making sure I understood the content.",
    author: {
      name: "Joshua",
      subject: "Algebra",
      image: "",
    },
  },
];

const TestimonialSection = () => {
  return (
    <section className="py-16 bg-rfpurple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            What Students Have to Say
          </h2>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
            Discover how rfLearn has transformed learning experiences for students
            from various backgrounds.
          </p>
        </div>

        <div className="mt-16">
          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            autoPlay={true}
            autoPlayDelay={5000}
            className="w-full max-w-5xl mx-auto"
          >
            <CarouselContent className="-ml-2 md:-ml-4">
              {testimonials.map((testimonial, index) => (
                <CarouselItem key={index} className="pl-2 md:pl-4 md:basis-1/2 lg:basis-1/3">
                  <Card className="bg-white border-gray-100 shadow-sm hover:shadow-md transition-shadow h-full">
                    <CardContent className="p-6">
                      <div className="flex items-start">
                        <div className="flex-shrink-0">
                          <Avatar className="h-12 w-12">
                            <AvatarImage src={testimonial.author.image} alt={testimonial.author.name} />
                            <AvatarFallback>{testimonial.author.name.charAt(0)}</AvatarFallback>
                          </Avatar>
                        </div>
                        <div className="ml-4">
                          <div className="text-sm font-medium text-gray-900">{testimonial.author.name}</div>
                          <div className="text-sm text-gray-500">{testimonial.author.subject}</div>
                        </div>
                      </div>
                      <div className="mt-4 text-gray-600 italic">
                        "{testimonial.content}"
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious />
            <CarouselNext />
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
